export default __webpack_public_path__ + "static/media/socialimpact4.100e45e8.jpeg";